import {
  CandidateVideoTokenBuilder,
  GetVideoTokenForEachCandidateInput,
  GetVideoTokenForEachCandidateOutput,
  GetVideoTokenForEachCandidateWithSPKUrlOutput,
} from '$store/modules/candidates-video-token/candidates.types';

export const getVideoTokenForEachCandidate = (
  builder: CandidateVideoTokenBuilder
) =>
  builder.query<
    GetVideoTokenForEachCandidateWithSPKUrlOutput[],
    GetVideoTokenForEachCandidateInput
  >({
    query: ({ candidateIds, videoPrompt }) => {
      const queryString = new URLSearchParams();
      candidateIds.forEach((singleCandidateId) =>
        queryString.append('Ids', `${singleCandidateId}`)
      );

      queryString.append('Name', videoPrompt);
      return {
        url: `candidates/video/token?${queryString.toString()}`,
        method: 'GET',
      };
    },
    transformResponse: (
      response: GetVideoTokenForEachCandidateOutput[]
    ): GetVideoTokenForEachCandidateWithSPKUrlOutput[] => {
      return response.map((singleResponse) => {
        const SPK_URL = new URL(import.meta.env.REACT_APP_SPK_URL as string);
        SPK_URL.pathname = 'record-video-with-token';
        SPK_URL.searchParams.append('token', singleResponse.Token);
        return { ...singleResponse, SPK_URL: SPK_URL.toString() };
      });
    },
  });
